<template>
  <div id="modalCreateCollaborator" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Adicionar Colaborador</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Usuário:
                  <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  :class="{
                    'is-invalid': v$.collaborator.userId.$errors.length,
                  }"
                  v-model="v$.collaborator.userId.$model"
                >
                  <option value="">Selecione um Usuário</option>
                  <option
                    v-for="user in users"
                    :key="user.id"
                    :value="user.id"
                    :title="user.name"
                  >
                    {{ user.name }}
                  </option>
                </select>
                <span
                  v-if="v$.collaborator.userId.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-sm btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-sm btn-primary"
              title="Adicionar"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Adicionar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'
import typeCollaboratorEnum from '@/enum/typeCollaboratorEnum'

export default {
  name: 'CreateCollaboratorModal',

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      users: [],
      collaborator: {
        userId: '',
        type: typeCollaboratorEnum.NORMAL,
      },
      disableButton: false,
    }
  },

  methods: {
    async getUsers() {
      try {
        this.users = await this.$store.dispatch(
          'getProjectCollaboratorsUnrelated',
          this.projectId,
        )

        if (this.users.length > 0) {
          showModal('modalCreateCollaborator')
        } else {
          this.$root.$refs.notification.warning(
            'Todos os usuários ativos cadastrado na plataforma já são colaboradores do sumário executivo.',
          )
          this.$emit('closeModal', false)
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          const response = await this.$store.dispatch(
            'saveProjectCollaborator',
            {
              projectId: this.projectId,
              collaborator: this.collaborator,
            },
          )

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      collaborator: {
        userId: {
          required,
        },
      },
    }
  },

  mounted() {
    this.getUsers()
  },
}
</script>
